/**
 * Prevenir zoom en la aplicación
 * - Desactiva zoom con teclado (Ctrl +/-)
 * - Desactiva zoom con rueda del ratón (Ctrl + scroll)
 * - Desactiva doble toque para zoom en dispositivos táctiles
 * - Desactiva pinch-to-zoom (pellizco con dos dedos)
 */
export function preventZoom(): void {
  if (typeof window === "undefined") {
    return;
  }

  // Prevenir zoom con teclado (Ctrl +/-)
  document.addEventListener("keydown", (e) => {
    if ((e.ctrlKey || e.metaKey) && (e.key === "+" || e.key === "-" || e.key === "=")) {
      e.preventDefault();
    }
  });

  // Prevenir zoom con rueda del ratón (Ctrl + scroll)
  document.addEventListener(
    "wheel",
    (e) => {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    },
    { passive: false },
  );

  // Prevenir doble toque para zoom
  let lastTouchEnd = 0;
  document.addEventListener(
    "touchend",
    (e) => {
      const now = Date.now();
      if (now - lastTouchEnd <= 500) {
        e.preventDefault();
      }
      lastTouchEnd = now;
    },
    { passive: false },
  );

  // Prevenir pinch-to-zoom (pellizco con dos dedos)
  document.addEventListener(
    "touchmove",
    (e) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    },
    { passive: false },
  );

  // Prevenir gesto de zoom en navegadores webkit
  document.addEventListener(
    "gesturestart",
    (e) => {
      if (typeof (e as any).preventDefault === "function") {
        (e as any).preventDefault();
      }
    },
    { passive: false },
  );
}
